import { authenticatedPatientSelector } from '../selectors/patients-selectors.ts';

module.exports = {
  controller: class AppointmentCancelController {

    static $inject = [
      '$ngRedux',
      '$scope',
      '$state',
      '$translate',
      'Appointments',
      'LoadingService',
      'PatientAppContextService',
      'ProductService',
      'PatientsService',
    ];

    constructor(
      $ngRedux,
      $scope,
      $state,
      $translate,
      Appointments,
      LoadingService,
      PatientAppContextService,
      ProductService,
      PatientsService,
    ) {
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$state = $state;
      this.$translate = $translate;
      this.Appointments = Appointments;
      this.LoadingService = LoadingService;
      this.PatientAppContextService = PatientAppContextService;
      this.ProductService = ProductService;
      this.PatientsService = PatientsService;
    }

    $onInit() {
      this.LoadingService.show();
      this.setStateConnection();

      // TODO: Use Redux when BOOK-1234 will be merged
      this.doctor = this.PatientAppContextService.context.patient.subscription.account;

      this.Appointments.get({ id: +this.$state.params.appointmentId }, (appointment) => {
        // Bring the availability start/end times down to the appointment level for convenience in the template
        appointment.startTime = appointment.availability.startTime;
        appointment.endTime = appointment.availability.endTime;

        // Apply a specific format for this screen to the date of the appointment
        appointment.formattedDate = moment(appointment.startTime).format(this.$translate.instant('date_format.dayname_day_month_and_year'));

        this.appointment = appointment;

        this.isLoading = false;
        this.LoadingService.hide();
      });
    }

    setStateConnection() {
      this.$scope.$on('$destroy', this.$ngRedux.connect(state => ({
        authenticatedPatient: authenticatedPatientSelector(state),
        group: state.group,
      }))(this));
    }

    cancelAppointment() {
      if (!this.isLoading) {
        this.isLoading = true;

        this.appointment.$cancel(() => {
          this.PatientsService
            .loadPatient(this.authenticatedPatient.id)
            .then(() => {
              this.$state.go('patients.id.home');
            });
        });
      }
    }

    get isWalkin() {
      return this.appointment && this.appointment.availability.reason.code.toUpperCase() === 'WALK_IN';
    }

    get isManitobaVaccination() {
      return this.ProductService.isAvailable('PATIENT_MULTI_BOOKING') && this.ProductService.isAvailable('MANITOBA_BOOKING');
    }

    get isSingleVaccination() {
      return !this.appointment.firstAppointmentStartDate;
    }
  },
  template: `
    <div ng-if="$ctrl.appointment">
      <div id="appointment-cancel" class="patient-bg">
        <div class="wrapper cancel-modal">
          <section>
            <h1 class="title -huge" translate="appointment_cancel.title"></h1>
            <div class="dark-section">
              <div ng-if="!$ctrl.isManitobaVaccination">
                <h2 ng-if="!$ctrl.isWalkin" class="title -secondary" translate="appointment_cancel.message"></h2>
                <h2 ng-if="$ctrl.isWalkin" class="title -secondary" translate="appointment_cancel.walkin"></h2>
                <span class="doctor-name" ng-if="$ctrl.appointment.availability.reason.accountFilter != 'forbidden'">{{'appointment_cancel.infos' | translate}} {{ $ctrl.appointment.account | displayName }}</span>
                <span ng-if="!$ctrl.isWalkin" translate="appointment_cancel.date" translate-values="{date: $ctrl.appointment.formattedDate, time: ($ctrl.appointment.startTime | timezoneFormat: $ctrl.group)}"></span>
                <span ng-if="$ctrl.isWalkin" translate="appointment_cancel.walkin_date" translate-values="{date: $ctrl.appointment.formattedDate, time: ($ctrl.appointment.startTime | timezoneFormat: $ctrl.group)}"></span>
              </div>
              <div ng-if="$ctrl.isManitobaVaccination">
                <h2 ng-if="!$ctrl.isSingleVaccination" class="title -secondary" translate="appointment_cancel.manitoba_vaccination_title"></h2>
                <h2 ng-if="$ctrl.isSingleVaccination" class="title -secondary" translate="appointment_cancel.message"></h2>
                <span ng-if="!$ctrl.isSingleVaccination" translate="appointment_cancel.manitoba_vaccination_message"></span>
                <span ng-if="$ctrl.isSingleVaccination" translate="appointment_cancel.date" translate-values="{date: $ctrl.appointment.formattedDate, time: ($ctrl.appointment.startTime | timezoneFormat: $ctrl.group)}"></span>
              </div>
              <div class="actions">
                <button class="hollow-button" ng-disabled="$ctrl.isLoading" ui-sref="patients.id.home" translate="appointment_cancel.keep_appointment"></button>
                <button class="button confirm-cancel-button" ng-class="{'-spinner -spinning': $ctrl.isLoading}" ng-disabled="$ctrl.isLoading" translate="appointment_cancel.confirm_cancel" ng-click="$ctrl.cancelAppointment()"></button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  `,
};



// WEBPACK FOOTER //
// ./main/components/appointment-cancel.js